var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 6762"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 157502",
    style: {
      fill: "none"
    },
    d: "M0 0h24v25H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.839-802.709a1.775 1.775 0 0 1-1.3-.534 1.775 1.775 0 0 1-.534-1.3v-13.613a1.775 1.775 0 0 1 .534-1.3 1.775 1.775 0 0 1 1.3-.534h13.613a1.775 1.775 0 0 1 1.3.534 1.775 1.775 0 0 1 .534 1.3v13.613a1.775 1.775 0 0 1-.534 1.3 1.775 1.775 0 0 1-1.3.534zm0-1.526h6.044v-14.239h-6.044a.3.3 0 0 0-.215.1.3.3 0 0 0-.1.215v13.613a.3.3 0 0 0 .1.215.3.3 0 0 0 .215.096zm7.569 0h6.044a.3.3 0 0 0 .215-.1.3.3 0 0 0 .1-.215v-6.807h-6.357zm0-8.645h6.357v-5.281a.3.3 0 0 0-.1-.215.3.3 0 0 0-.215-.1h-6.044z",
    transform: "translate(-137 823.646)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard_icon.8cfe24a902a08480117e293778c47521.svg";
export { ForwardRef as ReactComponent };